import React, { useState, useEffect } from 'react';
import { TrendingUp, ShoppingBag } from 'lucide-react';
import CreatorLayout from './CreatorLayout';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const AUTH_TOKEN_KEY = 'ivisora_auth_token';

const CreatorSales = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const LIMIT = 25;

  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (!token) return;
    setLoading(true);
    fetch(`${API_URL}/api/creator/sales?page=${page}&limit=${LIMIT}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : { items: [], total: 0 })
      .then(d => { setSales(d.items || []); setTotal(d.total || 0); setLoading(false); })
      .catch(() => setLoading(false));
  }, [page]);

  return (
    <CreatorLayout>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-gray-900">Sales</h1>
        {total > 0 && <span className="text-sm text-gray-400">{total} total sales</span>}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="w-5 h-5 border-2 border-violet-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : sales.length === 0 ? (
          <div className="text-center py-16">
            <ShoppingBag className="w-10 h-10 text-gray-200 mx-auto mb-3" />
            <p className="text-sm text-gray-500">No sales yet</p>
            <p className="text-xs text-gray-400 mt-1">Your template sales will appear here once buyers start purchasing.</p>
          </div>
        ) : (
          <>
            <div className="hidden md:grid grid-cols-5 gap-4 px-5 py-3 bg-gray-50 text-xs font-semibold text-gray-400 uppercase tracking-wide">
              <div className="col-span-2">Template</div>
              <div>Buyer</div>
              <div className="text-right">Amount</div>
              <div className="text-right">Date</div>
            </div>
            <div className="divide-y divide-gray-50">
              {sales.map((s, i) => (
                <div key={s.id || i} className="grid grid-cols-1 md:grid-cols-5 gap-2 md:gap-4 px-5 py-4 items-center">
                  <div className="col-span-2">
                    <p className="text-sm font-semibold text-gray-900 truncate">{s.template_name || '—'}</p>
                  </div>
                  <p className="text-sm text-gray-600">{s.buyer_name || 'Anonymous'}</p>
                  <p className="text-sm font-semibold text-emerald-600 md:text-right">
                    ${((s.amount_cents || 0) / 100).toFixed(2)}
                  </p>
                  <p className="text-xs text-gray-400 md:text-right">
                    {s.created_at ? new Date(s.created_at).toLocaleDateString() : '—'}
                  </p>
                </div>
              ))}
            </div>

            {total > LIMIT && (
              <div className="px-5 py-4 border-t border-gray-50 flex justify-end gap-2">
                {page > 1 && (
                  <button onClick={() => setPage(p => p - 1)} className="px-3 py-1.5 text-xs border border-gray-200 rounded-lg hover:bg-gray-50">
                    Previous
                  </button>
                )}
                {sales.length === LIMIT && (
                  <button onClick={() => setPage(p => p + 1)} className="px-3 py-1.5 text-xs bg-violet-600 text-white rounded-lg hover:bg-violet-700">
                    Next
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </CreatorLayout>
  );
};

export default CreatorSales;
